import Loginform from './LoginForm';

import Lottie from 'lottie-react';
import animationData from '../../assets/loginAnimation.json';
import Onboarding from './Onboarding';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { colors } from '../../colors';

const Login = ({
  handleOnboardingStart,
  handleOnboardingInProgress,
}: {
  handleOnboardingStart: () => void;
  handleOnboardingInProgress: (userId: number, onboardingStep: number) => void;
}) => {
  /** Show login form on the left
   * Show animation on the right
   *
   * Login form has title
   * username (should be email?) and password
   * Add label to register
   *
   * When registered pressed, screen scrolls to the left and onboarding flow begins
   * Line on the bottom with number of 'page'
   * doesn't need to be full page, we could see sliver of next step (with opacity)
   */

  return (
    <div
      style={{
        width: '100vw',
      }}
    >
      <div
        style={{
          paddingLeft: '10%',
          paddingRight: '10%',
          justifyContent: 'space-between',
          alignItems: 'center',
          display: 'flex',
          height: '100%',
        }}
      >
        <Loginform
          handleOnboardingStart={handleOnboardingStart}
          handleOnboardingInProgress={handleOnboardingInProgress}
        />
        <Lottie animationData={animationData} style={{ width: 450 }} />

        {/** Privacy Link */}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 16,
            right: 16,
            display: 'flex',
            justifyContent: 'end',
            borderTop: '0.5px #242424 solid',
          }}
        >
          <Link
            to={'/privacy'}
            style={{
              textDecoration: 'none',
              opacity: 0.7,
              marginRight: 16,
              marginLeft: 16,
            }}
          >
            <h4 style={{ color: colors.white }}>Privacy Policy</h4>
          </Link>
        </div>
      </div>
    </div>
  );
};

const Landing = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const [userId, setUserId] = useState<number | null>(null);
  const [activeOnboardingStep, setActiveOnboardingStep] = useState<
    number | undefined
  >();

  const handleOnboardingStart = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.clientWidth,
        behavior: 'smooth',
      });
    }
  };

  const handleOnboardingCancel = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: 0,
      });
    }
  };

  const handleOnboardingInProgress = (
    userId: number,
    onboardingStep: number,
  ) => {
    setUserId(userId);
    handleOnboardingStart();
    setActiveOnboardingStep(onboardingStep);
  };

  return (
    <div
      ref={scrollRef}
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        overflowX: 'hidden',
      }}
    >
      <div
        style={{
          flex: '0 0 100vw',
          display: 'flex',
          height: '100%',
        }}
      >
        <Login
          handleOnboardingStart={handleOnboardingStart}
          handleOnboardingInProgress={handleOnboardingInProgress}
        />
      </div>
      <div
        style={{
          flex: '0 0 100vw',
          display: 'flex',
          height: '100%',
        }}
      >
        <Onboarding
          userId={userId}
          onCancel={handleOnboardingCancel}
          activeOnboardingStep={activeOnboardingStep}
        />
      </div>
    </div>
  );
};

export default Landing;
